export default "__VITE_ASSET__CokTyx$S__"